export default "__VITE_PUBLIC_ASSET__fa17223a__"